<style scoped>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div class="ip_route_tables">
    <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    sort-by="rt_id"
    class="elevation-1"
    @dblclick:row="on_dbl_click"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title><h2 class="br">IPv4 route table</h2></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ props }">
            <v-btn @click="new_item(item)"
              color="primary" dark class="mb-2"
              v-bind="props"
            >
              Add IP route table
            </v-btn>
          </template>
          <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
            <v-card-title>
                <span class="headline">{{ form_title }}</span>
            </v-card-title>

            <v-card-text>
              <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-if="edited_index != -1"
                            v-bind:readonly="true"
                            v-model="edited_item.rt_id"
                            label="Route table ID"
                        ></v-text-field>

                        <ValidationProvider rules="required|rt_name" v-slot="{ errors }">
                        <v-text-field
                            v-bind:readonly="edited_index != -1"
                            v-model="edited_item.rt_name"
                            label="Route table name"
                        >
                        </v-text-field>
                        <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>          
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn v-if="edited_index === -1" color="blue darken-1" :disabled="invalid" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-form></v-card></ValidationObserver>
        </v-dialog>
      </v-toolbar>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="me-2"
        @click="edit_item(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="delete_item(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
    </template>
    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js"

export default {
name: "ip_route_table",
components: { Treeselect, ValidationProvider, ValidationObserver },
data: () => ({
    search: '',
    dialog: false,
    headers: [
        { text: 'Id', value: 'rt_id', align: 'start' },
        { text: 'Name', value: 'rt_name' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        rt_id: 0,
        rt_name: '',
    },
}),

computed: {
    form_title() {
        return this.edited_index === -1 ? 'Add IP route table' : 'IP route table'
    },
},

watch: {
},

created() {
    this.initialize()
},

methods: {
    initialize() {
        api_client.sh_ipv4_route_tables()
        .then(response => {
            this.items = response.data
        })
        .catch(error => {
            console.log(error)
        });
    },

    edit_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.dialog = true;
    },

    new_item() {
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });          
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.dialog = true;
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedIndex = -1
        });
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete IPv4 route table '" + 
            item.rt_name + "' ?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.del_ipv4_route_table({
            rt_name: this.edited_item.rt_name,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
        this.items.splice(this.edited_index, 1);
    },

    save() {
        let new_item = {
            rt_name: this.edited_item.rt_name,
        };

        api_client.add_ipv4_route_table(new_item)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
            }
            this.initialize();            
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
        this.close();
    },
}

};
</script>
  